import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

export const GetAllSetupsSubCategory = async ({
    limit,
    page,
    search,
    status = true,
    use_for = 'dropdown',
    with_than,
    other_than,
    job_type_uuid,
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);
    const jobTypeUuids = Array.isArray(job_type_uuid)
        ? job_type_uuid
        : job_type_uuid
          ? [job_type_uuid]
          : [];
    jobTypeUuids.forEach((uuid) => {
        if (uuid) queryList.push(`job_type_uuid[]=${encodeURIComponent(uuid)}`);
    });

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/sub-category?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetSetupsSubCategoryById = async ({uuid}) => {
    const queryList = [];
    if (uuid) queryList.push(`uuid=${uuid}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/sub-category/view?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
